







import { Component, Prop, Vue } from 'vue-property-decorator';
@Component
export default class Volkswagen extends Vue {
  @Prop() marketingCode!: string;

  get isVWNCode(): boolean {
    return this.marketingCode.length === 8 && this.marketingCode.startsWith('N');
  }
}
